import { z } from 'zod';
import { RoleSchema } from '@/modules/location/components/roleselector/Roles.ts';
import { PhoneSchema } from '@/modules/location/domain/PhoneSchema.ts';

export const ContactPersonSchema = z.object({
    name: z.string(),
    phone: PhoneSchema,
    role: RoleSchema,
});
export type ContactPerson = z.infer<typeof ContactPersonSchema>;
